
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import Company from 'features/company';
import MainLayout from 'global/MainLayout';
import { useRouter } from 'next/router';
import type { ReactElement } from 'react';
import sanitizer from 'string-sanitizer';

interface SymbolPageProps {
  symbol: string;
}

const SymbolPagePath = ({ symbol }: SymbolPageProps) => {
  const router = useRouter();
  const { param } = router.query;
  const activeTab = param?.[0];

  return <Company symbol={String(symbol).toUpperCase()} tab={activeTab} />;
};

export async function getServerSideProps(context) {
  const { params } = context;
  let { symbol } = params;
  symbol = symbol.replace('-', ' ');
  symbol = sanitizer.sanitize.keepSpace(symbol);
  symbol = symbol.replace(' ', '-');

  return {
    props: {
      symbol,
    },
  };
}

SymbolPagePath.getLayout = function getLayout(page: ReactElement) {
  return (
    <MainLayout isFlexibleWidth maxWidth={1000}>
      {page}
    </MainLayout>
  );
};

export default SymbolPagePath;
